// MUI theme for the Delivery page (VendorDeliveryZones.jsx + its tier editor)
// ONLY. It is the Truck Stops theme (same ink / amber palette, orange focus
// ring, no green or blue, labels above 48px fields) plus the few controls this
// page has that Truck Stops does not: radios and the distance chips in the
// boundary-area dialog, and input adornments.
import { createTheme } from '@mui/material/styles'
import { truckStopsTheme, TS, focusRing } from './truckStopsTheme'

export const DZ = {
  ...TS,
  body: '#344054',
  smallLabel: '#475467',
  segmentTrack: '#E4E7EC',
  noteBg: '#FFF8E8',
  noteBorder: '#F0D9A8',
  noteIcon: '#B45309',
  dashed: '#667085',
  frame: '#D0D5DD',
  ghostHover: '#EEF0F3',
  underline: '#7A8494'
}

export { focusRing }

const extra = base => ({
  MuiInputLabel: {
    ...base.components.MuiInputLabel,
    styleOverrides: {
      root: {
        ...base.components.MuiInputLabel.styleOverrides.root,
        color: DZ.smallLabel,
        '&.Mui-focused': { color: DZ.smallLabel }
      }
    }
  },
  MuiOutlinedInput: {
    styleOverrides: {
      ...base.components.MuiOutlinedInput.styleOverrides,
      // The page theme pads every input 0 14px; next to a "$" or "mi"
      // adornment the input itself needs no padding on that side.
      inputAdornedStart: { paddingLeft: 0 },
      inputAdornedEnd: { paddingRight: 0 }
    }
  },
  MuiInputAdornment: {
    styleOverrides: {
      root: { '& .MuiTypography-root': { color: DZ.smallLabel, fontWeight: 600 } }
    }
  },
  MuiRadio: {
    styleOverrides: {
      root: {
        color: TS.inputBorder,
        '&.Mui-checked': { color: TS.text },
        '&.Mui-focusVisible': focusRing
      }
    }
  },
  MuiFormControlLabel: {
    styleOverrides: {
      root: { minHeight: 44 },
      label: { fontSize: 15, color: TS.text }
    }
  },
  MuiChip: {
    styleOverrides: {
      root: { fontWeight: 600, fontSize: 14, '&.Mui-focusVisible': focusRing },
      sizeSmall: { height: 44, borderRadius: 10, '& .MuiChip-label': { paddingLeft: 14, paddingRight: 14 } },
      filledPrimary: {
        backgroundColor: TS.text,
        color: '#FFFFFF',
        '&:hover': { backgroundColor: TS.primaryHover }
      },
      outlined: {
        borderColor: DZ.frame,
        color: TS.icon,
        backgroundColor: TS.card
      }
    }
  }
})

export const deliveryZonesTheme = outer => {
  const base = truckStopsTheme(outer)
  return createTheme({ ...base, components: { ...base.components, ...extra(base) } })
}
